import { render } from "./LabelTextFieldListWidget.vue?vue&type=template&id=fdae1efa&ts=true"
import script from "./LabelTextFieldListWidget.ts?vue&type=script&lang=ts&external"
export * from "./LabelTextFieldListWidget.ts?vue&type=script&lang=ts&external"

import "./LabelTextFieldListWidget.vue?vue&type=style&index=0&id=fdae1efa&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__